import PropTypes from "prop-types";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import FaceEmoji, { UNAMUSED, DISAPPOINTED } from "../faceEmoji";
import classnamesBind from "classnames/bind";

import styles from "./MightLikeFailure.scss";

const classnames = classnamesBind.bind(styles);

const MightLikeFailure = ({
  emojiType,
  titleTranslationKey,
  subTitleTranslationKey,
  ariaLabel,
  additionalClasses,
}) => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <div
      className={classnames(styles.similarItemsFailure, additionalClasses)}
      data-testid="similarItemsFailure"
    >
      <FaceEmoji
        type={emojiType}
        className={styles.faceEmoji}
        ariaLabel={ariaLabel}
      />
      <span className={styles.title}>
        {getTranslation(titleTranslationKey)}
      </span>
      <span className={styles.text}>
        {getTranslation(subTitleTranslationKey)}
      </span>
    </div>
  );
};

MightLikeFailure.propTypes = {
  emojiType: PropTypes.oneOf([UNAMUSED, DISAPPOINTED]),
  titleTranslationKey: PropTypes.string.isRequired,
  subTitleTranslationKey: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export default MightLikeFailure;
